var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileTc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2E7DE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9493 18.5194C14.6678 18.3632 15.7211 17.9915 16.5494 17.3491C17.3976 16.6913 18.1206 15.6413 17.7584 14.2328C17.1418 11.8359 14.967 10.7776 13.9601 10.5329L13.8728 10.5117H13.783H12.0502H10.3174H10.2276L10.1403 10.5329C9.1334 10.7776 6.95853 11.8359 6.34202 14.2328C5.97975 15.6413 6.70278 16.6913 7.55094 17.3491C8.37925 17.9915 9.43255 18.3632 10.1511 18.5194L10.1556 18.5205L10.1904 18.5285C10.2198 18.5352 10.2614 18.5443 10.3134 18.5552C10.4172 18.5768 10.5637 18.6053 10.739 18.6336C11.0854 18.6898 11.5619 18.7486 12.0502 18.7486C12.5385 18.7486 13.015 18.6898 13.3614 18.6336C13.5366 18.6053 13.6831 18.5768 13.787 18.5552C13.839 18.5443 13.8806 18.5352 13.91 18.5285L13.9447 18.5205L13.9493 18.5194Z",
    fill: "white",
    stroke: "#2E7DE0",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0494,
    cy: 8.94737,
    r: 3.69737,
    fill: "white",
    stroke: "#2E7DE0",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTc);
export default __webpack_public_path__ + "static/media/profile_tc.f0d447c9e96d6c762167d9092dc87a19.svg";
export { ForwardRef as ReactComponent };